import React from 'react'
import NavMenu from '../../atoms/nav-menu/nav-menu'
import InicioSection from '../inicio-section/inicio-section'
import ParticipateSection from '../participate-section/participate-section'
import TopSection from '../top-section/top-section'
import './home-content.scss'
import { LOCALE } from '../../../constants/activity-constants'

const haveTopSection = () => {
  return LOCALE !== 'es-AR' && LOCALE !== 'es-UY'
}
const HomeContent = () => {
  return (
    <div className="f-home-content-container">
      <NavMenu />
      <InicioSection
        id="inicio"
        className="f-home-content-container__section"
      />
      <ParticipateSection
        id="participate"
        className="f-home-content-container__section"
      />
      {haveTopSection() && (
        <TopSection id="top" className="f-home-content-container__section" />
      )}
    </div>
  )
}

export default HomeContent
